import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Hashtag16 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={16}
    contrast={contrast}
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M6.74139 1.61409C6.80437 1.20469 6.52355 0.82175 6.11415 0.758766C5.70475 0.695782 5.32181 0.976605 5.25883 1.386L4.8182 4.25007H2.5C2.08579 4.25007 1.75 4.58586 1.75 5.00007C1.75 5.41429 2.08579 5.75007 2.5 5.75007H4.58743L3.89513 10.25H2C1.58579 10.25 1.25 10.5858 1.25 11C1.25 11.4142 1.58579 11.75 2 11.75H3.66436L3.25883 14.386C3.19584 14.7954 3.47667 15.1783 3.88606 15.2413C4.29546 15.3043 4.6784 15.0235 4.74138 14.6141L5.18201 11.75H9.66436L9.25883 14.386C9.19584 14.7954 9.47667 15.1783 9.88606 15.2413C10.2955 15.3043 10.6784 15.0235 10.7414 14.6141L11.182 11.75H13.5C13.9142 11.75 14.25 11.4142 14.25 11C14.25 10.5858 13.9142 10.25 13.5 10.25H11.4128L12.1051 5.75007H14C14.4142 5.75007 14.75 5.41429 14.75 5.00007C14.75 4.58586 14.4142 4.25007 14 4.25007H12.3358L12.7414 1.61409C12.8044 1.20469 12.5235 0.82175 12.1141 0.758766C11.7048 0.695782 11.3218 0.976605 11.2588 1.386L10.8182 4.25007L6.33585 4.25007L6.74139 1.61409ZM9.89513 10.25L10.5874 5.75007L6.10508 5.75007L5.41278 10.25H9.89513Z'
      fill='currentColor'
    />
  </Svg>
);

Hashtag16.displayName = 'Hashtag16';
export default Hashtag16;
